import { sendAnalytics } from '@playcastdotio/Analytics';
import type { QuickstartState } from '../QuickstartCoordinator';
import type { BaseAnalyticsProps } from './IQuickstartAnalyticsManager';
import { milestonePageLoadedSchema, milestoneStreamRenderedSchema, milestoneFirstInputSchema } from './schemas/milestoneEvents';

export function sendMilestonePageLoaded(baseProps: BaseAnalyticsProps, state: QuickstartState): void {
  const event = milestonePageLoadedSchema.parse({
    name: 'Milestone Page Loaded',
    eventId: 'milestone_page_loaded',
    role: 'player',
    flow: 'quickstart',
    campaignId: state.theme?.slug ?? 'unknown',
    pageLoadTime: state.pageLoadTime ?? Date.now(),
    persistentId: baseProps.persistentId,
    sessionId: baseProps.sessionId,
  });
  sendAnalytics(event);
}

export function sendMilestoneStreamRendered(baseProps: BaseAnalyticsProps, state: QuickstartState): void {
  const connectionDurationMs = state.pageLoadTime
    ? Date.now() - state.pageLoadTime
    : undefined;

  const event = milestoneStreamRenderedSchema.parse({
    name: 'Milestone Stream Rendered',
    eventId: 'milestone_stream_rendered',
    role: 'player',
    flow: 'quickstart',
    campaignId: state.theme?.slug ?? 'unknown',
    connectionDurationMs,
    persistentId: baseProps.persistentId,
    sessionId: baseProps.sessionId,
  });
  sendAnalytics(event);
}

export function sendMilestoneFirstInput(baseProps: BaseAnalyticsProps, state: QuickstartState): void {
  const event = milestoneFirstInputSchema.parse({
    name: 'Milestone First Input',
    eventId: 'milestone_first_input',
    role: 'player',
    flow: 'quickstart',
    campaignId: state.theme?.slug ?? 'unknown',
    persistentId: baseProps.persistentId,
    sessionId: baseProps.sessionId,
  });
  sendAnalytics(event);
}
